import { render, staticRenderFns } from "./WorkOrderInfo.vue?vue&type=template&id=24dd1d1c&scoped=true"
import script from "./WorkOrderInfo.vue?vue&type=script&lang=js"
export * from "./WorkOrderInfo.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderInfo.vue?vue&type=style&index=0&id=24dd1d1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dd1d1c",
  null
  
)

export default component.exports